export * from './clickout.directive';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/shared/clickout/index.ts